import {httpReq} from "@/htttpReq";
import store from "../store";
import hingedDoorImage from '@/assets/img/types/type-hinged-door.png'
import slidingDoorImage from '@/assets/img/types/type-sliding-door.png'
import windowImage from '@/assets/img/types/type-window-11mm.png'
import _, { kebabCase, toNumber } from "lodash";

function delay(t, val) {
  return new Promise(function(resolve) {
      setTimeout(function() {
          resolve(val);
      }, t);
  });
}

export default {
  namespaced: true,

  state: {
    currentStep: 1,
    currentPath: null,
    stepInTransition: false,
    quoteSent: false,
    estimateSent: false,
    paths: [
      {
        id: 1,
        cloned: false,
        complete: false,
        name: 'Hinged Door',
        image: hingedDoorImage,
        title: 'Create Hinged Door',
        subtitle: '(5 mins)',
        confirmText: 'Let’s create a Diamond Grille Hinged Door. When you are ready to proceed, click the Add a New Item button!',
        //TypeSection
        suggestedWidth: 820,
        suggestedDrop: 2040,
        typeId: 20,
        styleId: 54,
        gradeId: 546,

        lock: {
          normal: {
            defaultLockHeight: 1120,
            lockTypeSelection: _.kebabCase('Triple Lock Standard'),
            steps: [
              {
                id: 1,
                isModal: true,
                classes: 'shepherd-theme-custom width-full tw-px-5',
                actions: [
                  {
                    label: 'BACK',
                    icon: 'solid/step-backward',
                    fn: (vm) => {vm.goBackToPrevScreen()},
                  },
                  {
                    label: 'NEXT',
                    icon: 'solid/step-forward',
                    fn: (vm) => {
                      vm.nextStep()
                    },
                  }
                ],
                title: 'LOCK TYPE, HEIGHT & SIDE',
                description: `As you can see, our portal is very flexible when it comes to creating your door. To make ordering easy and quick, our default settings use the most popular options for that grade.`,
                items: [
                  {
                    label: 'Lock Type:',
                    description: 'Triple Lock Standard (Barrier grade default)',
                  },
                  {
                    label: 'Lock Height:',
                    description: '1120 mm Lock Box Bottom (We have many ways to enter lock height. What’s your way to measure it?)',
                  },
                  {
                    label: 'Lock Side:',
                    description: 'Left (did you know that more doors have the lock on the left?)',
                  },
                ]
              },
              {
                id: 2,
                isModal: false,
                classes: 'shepherd-theme-custom',
                target: `#lock-type-${_.kebabCase('Triple Lock Standard')}`,
                targetPosition: 'bottom-end',
                actions: [
                  {
                    label: 'BACK',
                    icon: 'solid/step-backward',
                    fn: async (vm) => {
                      vm.tour.hide()
                      vm.scrollToTop()
                      await store.dispatch('demoWizard/delayTransition')
                      vm.backStep()
                    },
                  },
                  {
                    label: 'NEXT',
                    icon: 'solid/step-forward',
                    fn: (vm) => {
                      vm.nextStep()
                    },
                  }
                ],
              },
              {
                id: 3,
                isModal: false,
                classes: 'shepherd-theme-custom',
                target: `#${_.kebabCase('LBB (Lock Box Bottom)')}`,
                targetPosition: 'bottom-end',
                actions: [
                  {
                    label: 'BACK',
                    icon: 'solid/step-backward',
                    fn: (vm) => {vm.backStep()},
                  },
                  {
                    label: 'NEXT',
                    icon: 'solid/step-forward',
                    fn: (vm) => {
                      vm.nextStep()
                    },
                  }
                ],
              },
              {
                id: 4,
                isModal: false,
                classes: 'shepherd-theme-custom',
                target: '#height-input',
                targetPosition: 'top-end',
                actions: [
                  {
                    label: 'BACK',
                    icon: 'solid/step-backward',
                    fn: (vm) => {vm.backStep()},
                  },
                  {
                    label: 'NEXT',
                    icon: 'solid/step-forward',
                    fn: async (vm) => {
                      await delay(300)
                      vm.nextStep()
                    },
                  }
                ],
              },
              {
                id: 5,
                isModal: false,
                classes: 'shepherd-theme-custom',
                target: '#lockSideSection',
                targetPosition: 'top-end',
                actions: [
                  {
                    label: 'BACK',
                    icon: 'solid/step-backward',
                    fn: (vm) => {vm.backStep()},
                  },
                  {
                    label: 'NEXT',
                    icon: 'solid/step-forward',
                    fn: (vm) => {
                      vm.next()
                    },
                  }
                ],
              },
            ]
          },
        },


        //Hinge
        hingeTypeName: _.kebabCase('Security Pin Hinge'),
        hingeDirectionName: _.kebabCase('Outswing'),
        hingeQuantityName: _.kebabCase('3 Hinges'),
        //Cylinder
        cylinder: _.kebabCase('5 Pin Cylinder'),
        //All options
        allOption: {
          steps:[
            {
              id: 1,
              isModal: true,
              actions: [
                {
                  label: 'BACK',
                  icon: 'solid/step-backward',
                  fn: (vm) => {vm.goBackToPrevScreen()},
                },
                {
                  label: 'NEXT',
                  icon: 'solid/step-forward',
                  fn: (vm) => {
                    // vm.scrollToDefaultOptions()
                    vm.tour.next()
                  },
                }
              ],
              title: 'CONGRATULATIONS!',
              description: `Your Diamond Grille Hinged Door has been successfully created. Now we need
              to save this item before we can email it to the client. But before we do so, let’s
              take a look at what the Default Options and Available Options for this product`
            },
            {
              id: 2,
              isModal: true,
              actions: [
                {
                  label: 'BACK',
                  icon: 'solid/step-backward',
                  fn: (vm) => {vm.tour.back()},
                },
                {
                  label: 'NEXT',
                  icon: 'solid/step-forward',
                  fn: (vm) => {
                    vm.scrollToAvailableOptions()
                    vm.tour.next()
                  },
                }
              ],
              title: 'DEFAULT OPTIONS',
              description: `Here you can adjust the selections you have made to your door by clicking the
              icons above. `,
              target: '#default-section',
              targetPosition: 'bottom',
            },
            {
              id: 3,
              isModal: true,
              actions: [
                {
                  label: 'BACK',
                  icon: 'solid/step-backward',
                  fn: (vm) => {
                    vm.scrollToDefaultOptions()
                    vm.tour.back()
                  },
                },
                {
                  label: 'SAVE ITEM',
                  icon: 'solid/save',
                  fn: (vm) => {vm.saveItem()},
                }
              ],
              title: 'AVAILABLE OPTIONS',
              target: '#available-section',
              targetPosition: 'top',
              description: `You can also customise your door by adding options such as:`,
              items: [
                {
                  label: 'Accessories:',
                  description: 'Including Hardware, Lengths & Sheets.',
                },
                {
                  label: 'Pet Doors:',
                  description: 'Multiple sizes and positions.',
                },
                {
                  label: 'Midrails & Mullions:',
                  description: 'Including position & colour choice.',
                },
                {
                  label: 'Out of Square: ',
                  description: `If your door is not quite square, you can adjust dimensions,
                  bow sides and see the mitre angles.`,
                },
                {
                  label: ' Additions:',
                  description: `Bug strips, seals, door stops. You can find the most common
                  additions here.`,
                },
              ]
            }
          ]
        }

      },
      {
        id: 2,
        cloned: false,
        complete: false,
        name: 'Sliding Door',
        image: slidingDoorImage,
        title: 'Create Sliding Door Set',
        subtitle: '(3 mins)',
        confirmText: 'Let’s create a T316 Stainless Security Mesh Sliding Door Set. When you are ready to create the first door panel, click the Add a New Item button!',
        //TypeSection
        suggestedWidth: 922,
        suggestedDrop: 2082,
        typeId: 21,
        styleId: 57,
        gradeId: 550,
        //Lock
        lock: {
          normal: {
            defaultLockHeight: 1150,
            lockTypeSelection: _.kebabCase('Triple Lock Lockwood 8653'),
            steps: [
              {
                id: 1,
                isModal: true,
                classes: 'shepherd-theme-custom width-full tw-px-5',
                actions: [
                  {
                    label: 'BACK',
                    icon: 'solid/step-backward',
                    fn: (vm) => {vm.goBackToPrevScreen()},
                  },
                  {
                    label: 'NEXT',
                    icon: 'solid/step-forward',
                    fn: (vm) => {
                      vm.nextStep()
                    },
                  }
                ],
                title: 'LOCK TYPE, HEIGHT & SIDE',
                description: `As you can see, our portal is very flexible when it comes to creating your door. To
                make ordering easy and quick, our default settings use the most popular options
                for that grade`,
                items: [
                  {
                    label: 'Lock Type:',
                    description: 'Triple Lock Lockwood 8653 (Security grade default)',
                  },
                  {
                    label: 'Lock Height:',
                    description: ' 1150 mm Lock Box Bottom (We have many ways to enter lock height. What’s your way to measure it?)',
                  },
                  {
                    label: 'Lock Side:',
                    description: 'Left (did you know that more doors have the lock on the left?)',
                  },
                ]
              },
              {
                id: 2,
                isModal: false,
                classes: 'shepherd-theme-custom',
                target: `#lock-type-${_.kebabCase('Triple Lock Lockwood 8653')}`,
                targetPosition: 'bottom-end',
                actions: [
                  {
                    label: 'BACK',
                    icon: 'solid/step-backward',
                    fn: async (vm) => {
                      vm.tour.hide()
                      vm.scrollToTop()
                      await store.dispatch('demoWizard/delayTransition')

                      vm.backStep()
                    },
                  },
                  {
                    label: 'NEXT',
                    icon: 'solid/step-forward',
                    fn: (vm) => {
                      vm.nextStep()
                    },
                  }
                ],
              },
              {
                id: 3,
                isModal: false,
                classes: 'shepherd-theme-custom',
                target: `#${_.kebabCase('LBB (Lock Box Bottom)')}`,
                targetPosition: 'bottom-end',
                actions: [
                  {
                    label: 'BACK',
                    icon: 'solid/step-backward',
                    fn: (vm) => {
                      vm.backStep()
                    },
                  },
                  {
                    label: 'NEXT',
                    icon: 'solid/step-forward',
                    fn: (vm) => {
                      vm.nextStep()
                    },
                  }
                ],
              },
              {
                id: 4,
                isModal: false,
                classes: 'shepherd-theme-custom',
                target: '#height-input',
                targetPosition: 'top-end',
                actions: [
                  {
                    label: 'BACK',
                    icon: 'solid/step-backward',
                    fn: (vm) => {
                      vm.backStep()
                    },
                  },
                  {
                    label: 'NEXT',
                    icon: 'solid/step-forward',
                    fn: async (vm) => {
                      await delay(300)
                      vm.nextStep()
                    },
                  }
                ],
              },
              {
                id: 5,
                isModal: false,
                classes: 'shepherd-theme-custom',
                target: '#lockSideSection',
                targetPosition: 'top',
                actions: [
                  {
                    label: 'BACK',
                    icon: 'solid/step-backward',
                    fn: (vm) => {
                      vm.backStep()
                    },
                  },
                  {
                    label: 'NEXT',
                    icon: 'solid/step-forward',
                    fn: (vm) => {
                      vm.next()
                    },
                  }
                ],
              },
            ]
          },
          clone: {
            defaultLockHeight: 1150,
            steps: [
              {
                id: 1,
                isModal: false,
                classes: 'shepherd-theme-custom',
                target: `#lock-type-${_.kebabCase('No Lock')}`,
                targetPosition: 'bottom-end',
                actions: [
                  {
                    label: 'BACK',
                    icon: 'solid/step-backward',
                    fn: (vm) => {vm.goBackToPrevScreen()},
                  },
                  {
                    label: 'NEXT',
                    icon: 'solid/step-forward',
                    fn: (vm) => {
                      const lockTypes = store.getters['orderPosition/getCurrentOptionSettings'].groups.default.choices
                      const defaultNoLockSelected = lockTypes.find(x => x.default && x.name === 'No Lock')
                      console.log('Def Nolock selected', defaultNoLockSelected)

                      if(defaultNoLockSelected){
                        vm.nextStep()
                      }else {
                        vm.errorsLock[`${_.kebabCase('No Lock')}`] = true
                        vm.$forceUpdate()
                      }
                    },
                  }
                ],
                stepOptions: {
                  beforeShowPromise: async function() {
                    store.commit('demoWizard/stepInTransition', true)
                    this['processing'] = true
                    console.log('before.... show....', this, this.processing)

                    await delay(1000)
                    store.commit('demoWizard/stepInTransition', false)

                    this['processing'] = false
                    console.log('after show....', this.processing)
                  }
                }
              },
              {
                id: 2,
                isModal: true,
                classes: 'shepherd-theme-custom width-full tw-px-5',
                actions: [
                  {
                    label: 'BACK',
                    icon: 'solid/step-backward',
                    fn: (vm) => {vm.backStep()},
                  },
                  {
                    label: 'NEXT',
                    icon: 'solid/step-forward',
                    fn: (vm) => {
                      vm.next()
                      vm.nextStep()
                    },
                  }
                ],
                title: 'DID YOU SPOT THE CHANGES?',
                description: `When we selected No Lock, we removed the Lock Height and Lock side settings.
                We also updated the price!`,
              },
              {
                id: 3,
                isModal: true,
                classes: 'shepherd-theme-custom width-full tw-px-5',
                actions: [
                  {
                    label: 'BACK',
                    icon: 'solid/step-backward',
                    fn: (vm) => {vm.backStep()},
                  },
                  {
                    label: 'NEXT',
                    icon: 'solid/step-forward',
                    fn: (vm) => {
                      // vm.next()
                      vm.nextStep()
                    },
                  }
                ],
                title: 'NO LOCK, NO CYLINDER!',
                description: `Because we removed the lock from the sliding door panel, our portal is smart
                enough to realise we may not need a cylinder either! So, let’s remove it! This will
                also impact the price.`,
              },
              {
                id: 4,
                isModal: false,
                classes: 'shepherd-theme-custom',
                target: '#btn-remove-cylinder',
                targetPosition: 'top',
                stepOptions: {
                  modalOverlayOpeningPadding: 10,
                  modalOverlayOpeningRadius: 0,
                  canClickTarget: true,
                },
              },
              {
                id: 5,
                isModal: false,
                classes: 'shepherd-theme-custom',
                target: '#lockSideSection',
                targetPosition: 'top',
                actions: [
                  {
                    label: 'BACK',
                    icon: 'solid/step-backward',
                    fn: (vm) => {vm.backStep()},
                  },
                  {
                    label: 'NEXT',
                    icon: 'solid/step-forward',
                    fn: (vm) => {
                      vm.next()
                    },
                  }
                ],
              },
            ]
          }
        },
        //Wheels
        wheelSelection: _.kebabCase('4 Wheels'),
        wheelTitle: 'WHEEL SELECTION',
        wheelDescription: `Again, we have many options. Based on the size of the panel, our portal determines the appropriate number of wheels. In this case, <span class="tw-font-bold tw-text-primary">4 WHEELS.</span>
        <br/><br/>
        You also may have wondered why we offer an option for no wheels to be added
        to the door? Sometimes customers want to have a fixed panel protect their glass
        doors, so we added this option to make our sliding doors as flexible as possible.
        `,
        //cylinder
        cylinder: _.kebabCase('5 Pin Cylinder'),
        //All options
        allOption: {
          steps:[
            {
              id: 1,
              isModal: true,
              actions: [
                {
                  label: 'BACK',
                  icon: 'solid/step-backward',
                  fn: (vm) => {vm.goBackToPrevScreen()},
                },
                {
                  label: 'NEXT',
                  icon: 'solid/step-forward',
                  fn: (vm) => {
                    vm.scrollToDefaultOptions()
                    vm.tour.next()
                  },
                }
              ],
              title: 'CONGRATULATIONS!',
              description: `Your First Sliding door panel has been successfully created. Now we need to
              create the Second Panel. But before we do so, let’s take a look at the
              Default Options and Available Options for this product.`
            },
            {
              id: 2,
              isModal: true,
              actions: [
                {
                  label: 'BACK',
                  icon: 'solid/step-backward',
                  fn: (vm) => {vm.tour.back()},
                },
                {
                  label: 'NEXT',
                  icon: 'solid/step-forward',
                  fn: (vm) => {
                    vm.scrollToAvailableOptions()
                    vm.tour.next()
                  },
                }
              ],
              title: 'DEFAULT OPTIONS',
              description: `Here you can adjust the selections you have made to your door by clicking the
              icons above. `,
              target: '#default-section',
              targetPosition: 'bottom',
            },
            {
              id: 3,
              isModal: true,
              actions: [
                {
                  label: 'BACK',
                  icon: 'solid/step-backward',
                  fn: (vm) => {
                    vm.scrollToDefaultOptions()
                    vm.tour.back()
                  },
                },
                {
                  label: 'NEXT',
                  icon: 'solid/step-forward',
                  fn: (vm) => {
                    vm.tour.next()
                  },
                }
              ],
              title: 'AVAILABLE OPTIONS',
              target: '#available-section',
              targetPosition: 'top',
              description: `You can also customise your door by adding options such as:`,
              items: [
                {
                  label: 'Accessories:',
                  description: 'Including Hardware, Lengths & Sheets.',
                },
                {
                  label: 'Pet Doors:',
                  description: 'Multiple sizes and positions.',
                },
                {
                  label: 'Midrails & Mullions:',
                  description: 'Including position & colour choice.',
                },
                {
                  label: 'Out of Square: ',
                  description: `If your door is not quite square, you can adjust dimensions,
                  bow sides and see the mitre angles.`,
                },
                {
                  label: ' Additions:',
                  description: `Bug Strips, F Interlocks and the most common sliding door
                  additions are here.`,
                },
              ]
            },
            {
              id: 4,
              isModal: true,
              actions: [
                {
                  label: 'BACK',
                  icon: 'solid/step-backward',
                  fn: (vm) => {
                    // vm.scrollToDefaultOptions()
                    vm.tour.back()
                  },
                },
                {
                  label: 'NEXT',
                  icon: 'solid/step-forward',
                  fn: (vm) => {
                    vm.tour.next()
                  },
                }
              ],
              title: 'NOW LET’S ADD THE SECOND PANEL!',
              // target: '#available-section',
              // targetPosition: 'top',
              description: `Once you have created the first panel of the set, any other panels you need to
              create are much easier. Shall we see how that works?`,
              stepOptions: {
                classes: 'shepherd-theme-custom width-full',
              }
            },
            {
              id: 5,
              isModal: true,
              actions: [
                {
                  label: 'BACK',
                  icon: 'solid/step-backward',
                  fn: (vm) => {
                    // vm.scrollToDefaultOptions()
                    vm.tour.back()
                  },
                },
                {
                  label: 'SAVE & CLONE',
                  icon: 'solid/step-forward',
                  fn: (vm) => {
                    store.dispatch('demoWizard/clone')
                    // vm.tour.next()
                  },
                }
              ],
              title: 'SAVING & CLONING',
              // target: '#all-option-save-and-clone',
              // targetPosition: 'top',
              stepOptions: {
                modalOverlayOpeningPadding: 10,
                modalOverlayOpeningRadius: 0,
                canClickTarget: true,
                classes: "shepherd-theme-custom width-full tw-px-5"
              },
              description: `First, let’s save and clone the current panel. Using our Save & Clone Feature, we
              can copy all the default settings, options and additions from the previous sliding
              door panel. When that is done, all we will need to do is adjust a few things and
              the second panel will be finished. <br/> <br/>
              When you are ready, click the Save & Clone Button.
              `,
            },
            {
              id: 6,
              isModal: true,
              actions: [
                // {
                //   label: 'BACK',
                //   icon: 'solid/step-backward',
                //   fn: (vm) => {
                //     // vm.scrollToDefaultOptions()
                //     vm.tour.back()
                //   },
                // },
                {
                  label: 'NEXT',
                  icon: 'solid/step-forward',
                  fn: (vm) => {
                    vm.tour.next()
                  },
                }
              ],
              title: 'THE ITEM HAS BEEN CLONED!',
              target: '#breadcrumbs',
              targetPosition: 'bottom',
              stepOptions: {
                modalOverlayOpeningPadding: 10,
                modalOverlayOpeningRadius: 0,
                canClickTarget: true,
              },
              description: `Great! Have you noticed how the dimensions, type of door, style and grade
              remained the same? All we have to do now is to remove the Lock and Cylinder
              and our XXO Sliding door set is done. To remove the Lock, let’s click on the icon
              located on the Default Options section..
              `,
            },
            {
              id: 7,
              isModal: false,
              actions: [
                {
                  label: 'BACK',
                  icon: 'solid/step-backward',
                  fn: (vm) => {
                    vm.tour.back()
                  },
                },
              ],
              target: `#available-option-${_.kebabCase('Lock')}`,
              targetPosition: 'bottom',
              stepOptions: {
                modalOverlayOpeningPadding: 10,
                modalOverlayOpeningRadius: 10,
                canClickTarget: true,
              },
            }
          ]
        },
        allOptionCloned: {
          steps:[
            {
              id: 1,
              isModal: true,
              actions: [
                {
                  label: 'SAVE ITEM',
                  icon: 'solid/save',
                  fn: (vm) => {
                    vm.saveItem()
                  },
                }
              ],
              title: 'CONGRATULATIONS!',
              description: `Your Second Sliding door panel has been successfully created. Now all we have
              to do is save the item and our XXO door set is done!`
            },
          ]
        }
      },
      {
        id: 3,
        cloned: false,
        complete: false,
        name: 'Window Screen',
        image: windowImage,
        title: 'Create Window Screen',
        subtitle: '(2 mins)',
        confirmText: 'Let’s create an Insect Window Screen. When you are ready to proceed, click the Add a New Item button!',
        //TypeSection
        suggestedWidth: 865,
        suggestedDrop: 1150,
        typeId: 23,
        styleId: 55,
        gradeId: 551,
        //Alloptions
        allOption: {
          steps:[
            {
              id: 1,
              isModal: true,
              actions: [
                {
                  label: 'BACK',
                  icon: 'solid/step-backward',
                  fn: (vm) => {vm.goBackToPrevScreen()},
                },
                {
                  label: 'NEXT',
                  icon: 'solid/step-forward',
                  fn: (vm) => {
                    vm.scrollToDefaultOptions()
                    vm.tour.next()
                  },
                }
              ],
              title: 'CONGRATULATIONS!',
              description: `Your Insect Screen Window has been successfully created. Now we need to
              save this item before we can email it to the client. But before we do so, let’s take
              a look at the Default Options and Available Options for this product.`
            },
            {
              id: 2,
              isModal: true,
              actions: [
                {
                  label: 'BACK',
                  icon: 'solid/step-backward',
                  fn: (vm) => {vm.tour.back()},
                },
                {
                  label: 'NEXT',
                  icon: 'solid/step-forward',
                  fn: (vm) => {
                    vm.scrollToAvailableOptions()
                    vm.tour.next()
                  },
                }
              ],
              title: 'DEFAULT OPTIONS',
              description: `Here you can adjust the selections you have made for your window by clicking
              the icons above.`,
              target: '#default-section',
              targetPosition: 'bottom',
            },
            {
              id: 3,
              isModal: true,
              actions: [
                {
                  label: 'BACK',
                  icon: 'solid/step-backward',
                  fn: (vm) => {
                    vm.scrollToDefaultOptions()
                    vm.tour.back()
                  },
                },
                {
                  label: 'SAVE ITEM',
                  icon: 'solid/save',
                  fn: (vm) => {vm.saveItem()},
                }
              ],
              title: 'AVAILABLE OPTIONS',
              target: '#available-section',
              targetPosition: 'top',
              description: `You can also customise your window screen by adding options such as:`,
              items: [
                {
                  label: 'Accessories:',
                  description: 'Including Hardware, Lengths & Sheets.',
                },
                {
                  label: 'Lift Tabs, Push Pins, Mesh Flaps & Fly screen Port Sets:',
                  description: 'We offer simple diagrams to determine exact specifications and position on the window.',
                },
                {
                  label: 'Midrails & Mullions:',
                  description: 'Including position & colour choice.',
                },
                {
                  label: 'Out of Square: ',
                  description: `If your door is not quite square, you can adjust dimensions,
                  bow sides and see the mitre angles.`,
                },
              ]
            }
          ]
        }

      },
    ]
  },

  getters: {
    state(state) {
      return state.stateList
    },
    getLockConfiguration(state) {
      return state.currentPath.cloned ? state.currentPath.lock.clone : state.currentPath.lock.normal
    },
    getAllOptionConfiguration(state) {
      return state.currentPath.cloned ? state.currentPath.allOptionCloned : state.currentPath.allOption
    }
  },

  mutations: {
    sendEstimate(state, type) {
      console.log('Sending.................', type)
      if(type === 'quote') {
        state.quoteSent = true
      }

      if(type === 'estimate') {
        state.estimateSent = true
      }
    },
    stepInTransition(state, payload) {
      state.stepInTransition = payload
    },
    setPath(state, payload) {
      state.currentPath = payload
      localStorage.setItem('demoWizardPathId', payload.id);
    },
    state(state, payload){
      state.stateList = payload;
    },
    goToStep(state, payload) {
      state.currentStep = payload
    },
    nextStep(state, payload) {
      state.currentStep = state.currentStep + 1
    },
    goBack(state, payload) {
      state.currentStep = state.currentStep - 1
    },
    completeTour(state, payload) {
      state.currentPath.complete = true
      const ids = state.paths.filter(x => x.complete).map(i => i.id)
      localStorage.setItem('demoWizardCompletedPaths', JSON.stringify(ids));
      window.location.reload()
    },
    cloned(state, payload) {
      state.currentPath.cloned = payload
    },
    setCompletedPaths(state, ids) {
      const paths = state.paths //.filter(x => ids.includes(x.id))
      paths.forEach(path => {
        if(ids.includes(path.id)){
          path.complete = true
        }
      });

      state.paths = paths
      localStorage.setItem('demoWizardCompletedPaths', JSON.stringify(ids));
    },
  },

  actions: {
    async sendEstimate({commit}, payload) {
      store.commit('preloader/preloader', true);
      try{
        await httpReq.post('order/send-quote', payload)
        localStorage.removeItem('demoWizardCompletedPaths')
        localStorage.removeItem('order_id')
        store.commit('demoWizard/sendEstimate', payload.action)
      }catch(error) {
        store.commit('errorsModal/openModal', error.response.data.errors);
      }finally {
        store.commit('preloader/preloader', false);
      }
    },
    async delayTransition({commit}, payload = 2000) {
      store.commit('demoWizard/stepInTransition', true)
      await delay(payload)
      store.commit('demoWizard/stepInTransition', false)
    },
    async completeTour({commit}) {
      await store.dispatch('orderPosition/save', 0);
      commit('completeTour')
    },
    async clone({commit}) {
      await store.dispatch('orderPosition/save', 2);
      commit('cloned', true)
    },
    state({commit}) {
      store.commit('preloader/preloader', true);
      httpReq.get('site/states')
        .then(response => {
          commit('state', response.data);
        })
        .finally(() => {
          store.commit('preloader/preloader', false);
        })
    },
  },
};
